const TARGET = Symbol('target');
class EventData {
    get target() {
        return this[TARGET];
    }
}
class AbortableEventData extends EventData {
    constructor(abort) {
        super();
        this.abort = abort;
    }
}
class AsyncAbortableEventData extends EventData {
    constructor(abort) {
        super();
        this.abort = abort;
    }
}
function setTarget(instance, target) {
    instance[TARGET] = target;
}
export { AbortableEventData, AsyncAbortableEventData, EventData, setTarget, };
//# sourceMappingURL=event-data.js.map